// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss';

// Get translatable strings
const strings = UncannyAutomatorBackend.logs.components.log.i18n.actions;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-header-action-delete-log' )
export class AutomatorLogHeaderActionDeleteLog extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// The link to edit the recipe
	@property( { type: String, attribute: 'log-delete-url' } ) accessor logDeleteURL;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-tooltip>
				<span class="tooltip-nowrap">${ strings.deleteLogEntry }</span>

				<uo-button
					slot="target"
					color="transparent"
					size="small"

					href="${ this.logDeleteURL }"

					onfirmation-heading=${ strings.irreversibleAction }
					confirmation-content=${ strings.sureDeleteRun }
					confirmation-button-label=${ strings.confirm }

					needs-confirmation
				>
					<uo-icon id="trash" size="16"></uo-icon>
				</uo-button>
			</uo-tooltip>
		`;
	}
}